import createStore from "zustand/vanilla";
import createReactStore from "zustand";
import { NetworkLayer } from "./layers/Network";
import { PhaserLayer } from "./layers/Renderer/Phaser";
import { HeadlessLayer } from "./layers/Headless";
import { LocalLayer } from "./layers/Local";
import { defineSystem, getComponentValue, getComponentValueStrict, runQuery } from "@latticexyz/recs";

export type Store = {
  networkLayer: NetworkLayer | null;
  headlessLayer: HeadlessLayer | null;
  localLayer: LocalLayer | null;
  phaserLayer: PhaserLayer | null;
};

export type UIStore = {
  networkLayer: NetworkLayer;
  headlessLayer: HeadlessLayer;
  localLayer: LocalLayer;
  phaserLayer: PhaserLayer;
};

export const store = createStore<Store>(() => ({
  networkLayer: null,
  headlessLayer: null,
  localLayer: null,
  phaserLayer: null,
}));

export const useStore = createReactStore(store);

export const useMUD = () => {
  const { networkLayer, headlessLayer, localLayer, phaserLayer } = useStore();

  if (networkLayer === null || headlessLayer === null || localLayer === null || phaserLayer === null) {
    throw new Error("Store not initialized");
  }

  if ((window as any).layers === undefined) {
    (window as any).layers = {
      networkLayer,
      headlessLayer,
      localLayer,
      phaserLayer,
    };

    (window as any).components = {
      ...networkLayer.components,
      ...headlessLayer.components,
      ...localLayer.components,
      ...phaserLayer.components,
    };

    (window as any).ecs = {
      getComponentValue,
      getComponentValueStrict,
      runQuery,
      defineSystem,
    };
  }

  return {
    networkLayer,
    headlessLayer,
    localLayer,
    phaserLayer,
  } as UIStore;
};

export const useAmalgema = () => {
  const { networkLayer } = useStore();

  if (networkLayer === null) {
    throw new Error("Network layer not initialized");
  }

  return networkLayer;
};
